import SunKingComponent from '../../components/SunKingComponent/SunKingComponent';


function SunKingPage({ URL}) {
  return (
    <div>
      <SunKingComponent URL={URL}/>
    </div>
  )
}

export default SunKingPage;
